import "./datatable.scss";
import {DataGrid, enUS, GridToolbar} from "@mui/x-data-grid";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import useFetch from "../../hooks/useFetch";

const DatatableOpen = ({columns}) => {
    const location = useLocation();
    const path = location.pathname.split("/")[1];
    const [list, setList] = useState([]);
    const { data, loading, error } = useFetch(`/detailticket`);


    useEffect(() => {
        setList(data);
    }, [data]);




    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <Link to={`/solve/${params.row.ticket_id}`} style={{textDecoration: "none"}}>
                            <div className="viewButton">View</div>
                        </Link>
                        <Link to={`/solve/update/${params.row.ticket_id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Update Solved
                            </div>
                        </Link>
                        <Link to={`/closed/update/${params.row.ticket_id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Update Close
                            </div>
                        </Link>

                    </div>
                );
            },
        },
    ];
    return (
        <div className="datatable">
            <div className="datatableTitle">
                Ticket {path.toUpperCase()}

               <div>

                </div>
            </div>
            <DataGrid
                className="datagrid"
                rows={list}
                columns={columns.concat(actionColumn)}
                localeText={enUS.components.MuiDataGrid.defaultProps.localeText}
                components={{
                    Toolbar: GridToolbar
                }}
                pageSize={10}
                rowsPerPageOptions={[10]}
                checkboxSelection
                getRowId={(row) => row.id}

            />
        </div>
    );
};

export default DatatableOpen;
